import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WelcomePlannerViewService {
  // Signals states
  private _isAllReadyViewShown = signal<boolean>(true);
  public isAllReadyViewShown = this._isAllReadyViewShown.asReadonly();

  // Setters
  setIsAllReadyViewShown(isShown: boolean): void {
    this._isAllReadyViewShown.set(isShown);
  }
}
